var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlayLg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Iconly_Bold_Play",
    "data-name": "Iconly/Bold/Play",
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.18,
    height: 65.18,
    viewBox: "0 0 65.18 65.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Play",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76261",
    "data-name": "Path 76261",
    d: "M32.59,0A32.59,32.59,0,1,1,0,32.609,32.637,32.637,0,0,1,32.59,0ZM28.878,19.652a4.377,4.377,0,0,0-1.982.472,4.078,4.078,0,0,0-1.762,1.949,21.023,21.023,0,0,0-.566,2.3,50.263,50.263,0,0,0-.535,8.207,58.16,58.16,0,0,0,.472,7.955,17.818,17.818,0,0,0,.755,2.861,3.96,3.96,0,0,0,3.492,2.138h.126a10.947,10.947,0,0,0,2.926-.88c3.335-1.384,9.909-5.691,12.551-8.553h0l.189-.189a12.956,12.956,0,0,0,.881-1.006,3.786,3.786,0,0,0,.755-2.292,3.972,3.972,0,0,0-.818-2.456c-.126-.126-.6-.66-1.038-1.1a48.094,48.094,0,0,0-12.835-8.678A10.706,10.706,0,0,0,28.878,19.652Z",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayLg);
export default __webpack_public_path__ + "static/media/play_lg.7e6c42a3578e6aee4755977489d2660a.svg";
export { ForwardRef as ReactComponent };